<script>
    export let color;
</script>
<svg
  enable-background="new 0 0 512 512"
  version="1.1"
  viewBox="0 0 512 512"
  xml:space="preserve"
  xmlns="http://www.w3.org/2000/svg"
  width="36px"
  fill={color}
  height="36px">
  <path
    d="m314.67 391.47c6.4-21.333 19.2-40.533 36.267-55.467 32-26.667 52.267-67.2
    52.267-112 0-83.2-69.333-151.47-154.67-147.2-75.734 3.2-137.6 67.2-139.73
    142.93-1.067 46.934 19.2 88.534 52.267 116.27 18.133 14.933 30.933 34.133
    37.333 55.467h116.27z"
     />
  <path
    d="m242.13 393.6h9.6l-42.667-158.93h3.2c5.333 0 10.667-2.133 14.933-6.4
    2.133-2.133 4.267-3.2 7.467-3.2s5.333 1.067 7.467 3.2c7.467 8.533 20.267
    8.533 27.733 0 2.133-2.133 4.267-3.2 7.467-3.2 2.133 0 5.333 1.067 7.467 3.2
    4.267 4.267 8.533 6.4 14.933 6.4h3.2l-41.6 158.93h9.6l43.733-166.4c0-2.133
    0-4.267-2.133-5.333-2.133-1.067-4.267 0-5.333 1.067-2.133 2.133-4.267
    3.2-6.4 3.2-3.2
    0-5.333-1.067-8.533-3.2-4.267-4.267-8.533-6.4-13.867-6.4s-9.6 2.133-13.867
    6.4-10.667 4.267-14.933 0c-3.2-4.267-8.533-6.4-13.867-6.4-5.333 0-10.667
    2.133-13.867 6.4-2.133 2.133-5.333 3.2-8.533 3.2-2.133
    0-5.333-1.067-6.4-3.2-1.067-1.067-3.2-2.133-5.333-1.067-2.133 1.067-3.2
    3.2-2.133 5.333l42.666 166.4z"
    fill="#fff" />
  <g fill="#344A5E">
    <path
      d="m222.93 489.6c5.334 12.8 18.134 22.4 33.067 22.4s27.733-9.6
      33.067-22.4h-66.134z" />
    <path
      d="m295.47 490.67h-77.867c-10.667
      0-19.2-8.533-19.2-19.2v-81.067h116.27v81.067c0 10.666-8.534 19.2-19.2
      19.2z" />
  </g>
  <g fill="#415A6B">
    <path
      d="m313.6 430.93h-115.2c-6.4 0-11.733-5.333-11.733-11.733s5.333-11.733
      11.733-11.733h115.2c6.4 0 11.733 5.333 11.733 11.733s-5.333 11.733-11.733
      11.733z" />
    <path
      d="m313.6 468.27h-115.2c-6.4 0-11.733-5.333-11.733-11.733s5.333-11.733
      11.733-11.733h115.2c6.4 0 11.733 5.333 11.733 11.733 0 6.399-5.333
      11.733-11.733 11.733z" />
  </g>
  <g fill={color}>
    <path
      d="m256 0c-5.333 0-10.667 4.267-10.667 10.667v36.267c0 5.333 4.267 10.667
      10.667 10.667s10.667-4.267
      10.667-10.667v-36.267c0-6.4-5.334-10.667-10.667-10.667z" />
    <path
      d="m113.07 65.067c-4.267-4.267-10.667-4.267-14.933 0s-4.267 10.667 0
      14.933l25.6 25.6c4.267 4.267 10.667 4.267 14.933 0s4.267-10.667
      0-14.933l-25.6-25.6z" />
    <path
      d="m80 212.27h-36.267c-5.333 0-10.667 4.267-10.667 10.667 0 5.333 4.267
      10.667 10.667 10.667h36.267c5.333 0 10.667-4.267 10.667-10.667
      0-5.334-5.334-10.667-10.667-10.667z" />
    <path
      d="m123.73 340.27-25.6 25.6c-4.267 4.267-4.267 10.667 0 14.933s10.667
      4.267 14.933 0l25.6-25.6c4.267-4.267 4.267-10.667
      0-14.933s-10.666-4.267-14.933 0z" />
    <path
      d="m388.27 340.27c-4.267-4.267-10.667-4.267-14.934 0s-4.267 10.667 0
      14.933l25.6 25.6c4.267 4.267 10.667 4.267 14.933 0s4.267-10.667
      0-14.933l-25.599-25.6z" />
    <path
      d="m468.27 212.27h-36.267c-5.333 0-10.667 4.267-10.667 10.667 0 5.333
      4.267 10.667 10.667 10.667h36.267c5.333 0 10.667-4.267 10.667-10.667-1e-3
      -5.334-4.267-10.667-10.667-10.667z" />
    <path
      d="m398.93 65.067-25.6 25.6c-4.267 4.267-4.267 10.667 0 14.933 4.267 4.267
      10.667 4.267 14.933 0l25.6-25.6c4.267-4.267 4.267-10.667
      0-14.933s-10.666-4.267-14.933 0z" />
  </g>

</svg>
